"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const clsx_1 = require("clsx");
exports.Button = (0, react_1.forwardRef)(({ className, variant = 'primary', size = 'md', loading, disabled, children, ...props }, ref) => {
    return ((0, jsx_runtime_1.jsxs)("button", { className: (0, clsx_1.clsx)('inline-flex items-center justify-center rounded-md font-medium transition-colors', 'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2', 'disabled:pointer-events-none disabled:opacity-50', 
        // Variants
        {
            'bg-stone-900 text-white focus-visible:ring-stone-500': variant === 'primary',
            'bg-stone-100 text-stone-900 focus-visible:ring-stone-500': variant === 'secondary',
            'border border-stone-300 bg-transparent text-stone-700 focus-visible:ring-stone-500': variant === 'outline',
            'text-stone-700 focus-visible:ring-stone-500': variant === 'ghost',
        }, 
        // Sizes
        {
            'h-8 px-3 text-sm': size === 'sm',
            'h-10 px-4 text-sm': size === 'md',
            'h-12 px-6 text-base': size === 'lg',
        }, className), disabled: disabled || loading, ref: ref, ...props, children: [loading && ((0, jsx_runtime_1.jsxs)("svg", { className: "mr-2 h-4 w-4 animate-spin", xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", children: [(0, jsx_runtime_1.jsx)("circle", { className: "opacity-25", cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "4" }), (0, jsx_runtime_1.jsx)("path", { className: "opacity-75", fill: "currentColor", d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" })] })), children] }));
});
exports.Button.displayName = 'Button';
